import { Tab } from "@material-ui/core";
import { useEffect, useState } from "react";

export const TabItem = ({
    label,
    value,
    index,
    icon,
    ...otherProps
}) => {
    const isMobileLimit = 800;
    const [isMobile, setIsMobile] = useState(window.innerWidth <= isMobileLimit);

    useEffect(() => {
        const onWindowResize = () => setIsMobile(window.innerWidth <= isMobileLimit);

        window.addEventListener('resize', onWindowResize);

        return () => window.removeEventListener('resize', onWindowResize);
    }, []);

    return (
        <Tab
            id={`simple-tab-${index}`}
            aria-controls={`simple-tabpanel-${index}`} 
            style={{ minWidth: "20%" }}
            label={!isMobile ? label : undefined}
            value={value}
            icon={isMobile ? icon : undefined}
            {...otherProps} />
    );
};